module.exports = {"TXTCLI_Late_Registration":{"id":"TXTCLI_Late_Registration","defaultMessage":"Inscription tardive","track":"Late Registration"}}